<template>
  <div class="w-100">
    <div class="row">
      <div class="d-grid gap-2 d-md-flex justify-content-md-start">
        <span class="fsize-16 me-3">Withdraw Status</span>
        <select v-model="selected" class="p-2">
          <option v-for="data in listStatus" :key="data.id" :value="data">
            {{ data.value }}
          </option>
        </select>

        <button class="fw-bold p-2 btn bg-white shadow-sm bg-body rounded" data-bs-target="#exampleModal" data-bs-toggle="modal" type="button"
          @click="loadSetting()">
          <img
              width="18"
              src="@/assets/sidebar/sidebar-icon-manage.svg"
              alt=""
            />
          Withdraw Setting
        </button>
      </div>
    </div>

    <ApprovedPage v-if="selected.id === 'APPROVED'" />
    <RejectPage v-else-if="selected.id === 'REJECT'" />
    <PendingPage v-else />
    <div id="exampleModal" ref="exampleModal" aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade"
      tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="exampleModalLabel" class="modal-title">WITHDRAW SETTING</h5>
            <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3 row">
              <div class="d-flex col-sm-4 col-form-label">
                <label for="minAmount">Minimum Amount<span class="text-danger">*</span></label>
                <PopOver :text="infoMinimum" :containerStyle="{alignSelf: 'self-start'}">
                  <img alt="info" class="info-icon" src="@/assets/ic_info.png" />
                </PopOver>
              </div>
              <div class="col-sm-8">
                <CustomInput
                    :isRupiah="true"
                    type="number"
                    placeholder="0"
                    :value="withdrawSetting.minimumWithdraw"
                    @onChange="(value)=> withdrawSetting.minimumWithdraw = value"
                    :maxlength="23"
                    :error="errors.minimumWithdraw"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <div class="d-flex col-sm-4 col-form-label">
                <label for="maxAmount">Maximum Amount<span class="text-danger">*</span></label>
                <PopOver :text="infoMaximum" :containerStyle="{alignSelf: 'self-start'}">
                  <img alt="info" class="info-icon" src="@/assets/ic_info.png" />
                </PopOver>
              </div>
              <div class="col-sm-8">
                <CustomInput
                  :isRupiah="true"
                  type="number"
                  placeholder="0"
                  :value="withdrawSetting.maximumWithdraw"
                  @onChange="(value)=> withdrawSetting.maximumWithdraw = value"
                  :maxlength="23"
                  :error="errors.maximumWithdraw"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <div class="d-flex col-sm-4 col-form-label">
                <label for="adminFee">Admin Fee</label>
                <PopOver :text="infoAdminFee" :containerStyle="{alignSelf: 'self-start'}">
                  <img alt="info" class="info-icon" src="@/assets/ic_info.png" />
                </PopOver>
              </div>
              <div class="col-sm-8">
                <CustomInput
                  :isRupiah="true"
                  type="number"
                  placeholder="0"
                  :value="withdrawSetting.adminFee"
                  @onChange="(value)=> withdrawSetting.adminFee = value"
                  :maxlength="23"
                  :error="errors.adminFee"
                />
              </div>
            </div>
            <div class="mb-3 row">
              <div class="d-flex col-sm-4 col-form-label">
                <label for="frequency">Frequency<span class="text-danger">*</span></label>
                <PopOver :text="infoFrequency" :containerStyle="{alignSelf: 'self-start'}">
                  <img alt="info" class="info-icon" src="@/assets/ic_info.png" />
                </PopOver>
              </div>
              <div class="col-sm-8">
                <div class="d-flex gap-3">
                  <CustomInput
                    type="number"
                    placeholder="0"
                    :value="withdrawSetting.frequencyWithdraw"
                    @onChange="(value)=> withdrawSetting.frequencyWithdraw = value"
                    :maxlength="16"
                    :inputClass="'w-50'"
                    :error="errors.frequencyWithdraw"
                  />
                  <SlotDropdown 
                    :containerClass="'input-group-text w-50'" 
                    :containerStyle="{height:'fit-content'}"
                    :options="frequencyOptions"
                    :value="frequencyValue" @onChange="handleFrequencyChange">
                    <span id="inputNote">{{frequencyValue.label}}</span>
                  </SlotDropdown>
                </div>
              </div>
            </div>

            <div class="mb-3 row">
              <label class="col-sm-12 col-form-label" for="inputNote">Withdraw Policy Content</label>
              <div class="col-sm-12">
                <TextEditor :value="withdrawSetting.policyWithdraw" @onChange="(val) => withdrawSetting.policyWithdraw = val"/>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-outline-danger" data-bs-dismiss="modal" type="button">
              <strong>CANCEL</strong>
            </button>
            <button class="btn btn-danger text-white" type="button" @click="updateSetting()">
              <strong>UPDATE</strong></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PendingPage from "./Pending.vue";
  import ApprovedPage from "./Approced.vue";
  import RejectPage from "./Reject.vue";
  import PopOver from "@/components/PopOver.vue";
  import SlotDropdown from "@/components/SlotDropdown.vue"
  import CustomInput from "@/components/CustomInput.vue"
  import TextEditor from "@/components/TextEditor.vue"

  export default {
    components: {
      TextEditor,
      PendingPage,
      ApprovedPage,
      RejectPage,
      PopOver,
      SlotDropdown,
      CustomInput
    },
    data() {
      return {
        selected: {
          value: "Pending Withdraw",
          id: "PENDING"
        },
        listStatus: [{
            value: "Pending Withdraw",
            id: "PENDING"
          },
          {
            value: "Approved Withdraw",
            id: "APPROVED"
          },
          {
            value: "Rejected Withdraw",
            id: "REJECT"
          },
        ],
        withdrawSetting: {
          minimumWithdraw: 0,
          maximumWithdraw: 0,
          adminFee: 0,
          frequencyWithdraw: 0,
          policyWithdraw: ""
        },
        errors: {},
        frequencyValue: {
          label: "Per Day",
          value: 'day'
        },
        frequencyOptions: [{
          label: "Per Day",
          value: 'day'
        }, ],
        infoMinimum: "The minimum amount Seller can withdraw from their balance (per withdraw)",
        infoMaximum: "The maximum amount Seller can withdraw from their balance (per withdraw)",
        infoFrequency: "This is to set how many times Seller can withdraw their balance",
        infoAdminFee: "Admin Fee paid by Seller per Request Withdraw",
      };
    },
    methods: {
      handleFrequencyChange(data) {
        this.frequencyValue = data
      },
      async loadSetting() {
        const response = await this.$store.dispatch("withdraw/setting");
        this.withdrawSetting = {
          minimumWithdraw: response.Items.minimum_withdraw,
          maximumWithdraw: response.Items.maximum_withdraw,
          adminFee: response.Items.admin_fee,
          frequencyWithdraw: response.Items.frequency_withdraw,
          policyWithdraw: response.Items.policy_withdraw
        }

      },
      handleValidation(data){
        let errors = {}

        if(data.minimumWithdraw > data.maximumWithdraw) 
          errors.minimumWithdraw = "Minimum amount cannot be greater than maximum amount"
        if(data.minimumWithdraw < 1) 
          errors.minimumWithdraw = "Value less than Rp1"

        if(data.maximumWithdraw < data.minimumWithdraw) 
          errors.maximumWithdraw = "Maximum amount cannot be lesser than minimum amount"
        if(data.maximumWithdraw < 1) 
          errors.maximumWithdraw = "Value less than Rp1"
        
        if(!data.adminFee && data.adminFee !== 0)
          errors.adminFee = "Admin fee cannot be empty"

        if(!data.frequencyWithdraw && data.frequencyWithdraw !== 0)
          errors.frequencyWithdraw = "Frequency cannot be empty"

        console.log({errors})

        if(Object.keys(errors).length){
            this.errors= errors
            return false
        }else{
            this.errors= {}
        }
        return true
      },
      async updateSetting() {
        try{
          if(!this.handleValidation(this.withdrawSetting)){
              // stop process if validation failed
              return
          }
          await this.$store.dispatch("withdraw/updateSetting", this.withdrawSetting);
          this.$swal({
            icon: "success",
            title: "Success update withdraw setting.",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.$router.go();
          });
        }catch(error){
          console.log("ERROR : ", error)
          this.$swal({
            title: error.response?.data?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      },
    },
  };
</script>

<style scoped>
  .info-icon {
    width: 12px;
    height: 12px;
    align-self: center;
    margin-left: 3px;
    cursor: pointer;
  }
</style>